import { Empty } from '@tcweb/connect-ui';
import type { JSX } from 'solid-js';

export interface FxWorkspaceEmptyStateProps {
  readonly icon: string;
  readonly title: string;
  readonly message: string;
  readonly dataTestId: string;
  readonly content?: JSX.Element;
}

export const FxWorkspaceEmptyState = (
  props: FxWorkspaceEmptyStateProps
): JSX.Element => (
  <Empty
    icon={props.icon}
    title={props.title}
    message={props.message}
    class="flex-1 w-100"
    data-testid={props.dataTestId}
    isSmallContainer={true}
    content={props.content}
  />
);
